import {observer, pluralize, useEffect, React, classNames, Fragment} from '@api'
import {Classes, Icon, MenuDivider} from '@blueprintjs/core'
import {TabNode} from '@flexlayout'
import {Orientation} from '@material-ui/core'
import {AspectRatioSharp, Filter1, ImageSearchSharp, Layers, PaletteSharp, PlaylistAdd, RecentActors, VerticalAlignTop, ViewColumn, ViewComfy, ViewWeek } from '@material-ui/icons'
import {
  BuilderCardLoader,
  ContextMenuItem,
  useBuilderCardStore,
  useCardFieldStore,
  GroupByGroupContextMenu,
  DefaultCatalogContextMenuItems,
  NoImagePlaceholder,
  CatalogImageSourceMenuItems,
  CardImageRatioMenuItems,
  CatalogItemPreviewMenuItem,
  SpecContextMenuItem,
  ContextMenuItemProps,
  BuilderCardRelationshipsContextMenuItem,
  CardSizeSlider,
  useNewWorkspaceRelationshipStore,
  WorkspaceRelationshipStoreContext,
  useStores,
  ImageUrlWithHD,
  BuilderCardButtons,
  VipLocalStore,
  IFlexLayoutWhiteboardTabConfig,
  useImageSourceToolbarButtonStore
} from '@modules'
import {icons} from '@stores/ui'
import {MyImage, PrimaryIconButton, NumberBadge} from 'centric-ui-components'
import {action, observable} from 'mobx'
import * as css from './BuilderCardContextMenu.css'
import {ICatalogFieldConfig, nav, TooltipLocation, useCatalog, WorkspaceConfig} from '@stores'
import {SketchPicker} from 'react-color'

export const BuilderCardContextMenuCss = css
export const BuilderCardContextMenuItems = observer(function BuilderCardContextMenuItems({menuItemsTop}: { menuItemsTop? }) {
  const store = useBuilderCardStore(),
    fieldStore = useCardFieldStore(),
    {props: {readOnly}} = store,
    catalog = useCatalog(),
    {selection: {selectedItemCount}} = catalog

  useEffect(() => {
    store.isShowingContextMenu = true

    return () => {
      store.isShowingContextMenu = false
    }
  }, [])

  //<div className={css.text}>{store.cardTitle}</div>}>
  return (<Fragment>
    {false && !fieldStore && <Fragment>
      {/*<MenuDivider title={catalog.catalogItemName} />*/}
		<InlineBuilderCardMenuItem_BuilderCard children={null}/>
	</Fragment>}

    {/*<InlineBuilderCardMenuItem showText small orientation='horizontal' />*/}

    {/* --- Product            (toolbar buttons) */}
    {!readOnly &&
	 <MenuDivider className={css.titleDivider} title={<div className={css.toolbar}>
       <span className={css.title}>{catalog.catalogItemName}</span>
       <div className={css.inlineButtons}><BuilderCardButtons inline/></div>
     </div>}/>}

    {/*  A ListPreviewCard Product card and it's submenu */}
    <ProductCardInlinePreviewSubmenu/>

    {menuItemsTop}

    {/* Showing MPV -> Colorway, user right clicks on one of the colorway images (via image source grid/stack) */}
    {store.contextItemField && <Fragment>
		<MenuDivider title={catalog.labelForField(store.contextItemField)}/>
		<BuilderStoreContextItemMenuItem/>
	</Fragment>}

    {/*<BuilderCardRelationshipsContextMenuItem dividerBefore className={css.relationships} popoverProps={{className: css.relationshipsPopover}} />*/}

    <MenuDivider />
    <SendContextCardsToWhiteboardMenuItem />
    {/* Actions involving the current catalog item */}
    {!readOnly && <Fragment>
		<MenuDivider/>
        {/*<PasteImagesMenuItem/>*/}
		  <DuplicateCatalogItem/>
        {/*<CopyCatalogItem/>*/}
		  <DeleteCatalogItem/>
		  <ToggleActive/>

		  <PublishCatalogItemMenuItem dividerBefore dividerAfter/>
		  <ToggleLevelOfDetail dividerBefore/>

		<GoToSeason dividerBefore dividerAfter/>


	</Fragment>}

    <OpenProductDetails/>
    {/*<SurfaceNestedFieldsToggleMenuItem />*/}

    {false && store.isEditable && catalog.isActionButtonEnabled('uploadImages') && <Fragment>
		<MenuDivider/>
      {/*<ContextMenuItem icon={<ImageSharp/>} text={'Upload Image(s)'} noSubmenuPadding>*/}
      {/*  <UppyImageUploader/>*/}
      {/*</ContextMenuItem>*/}
		<BuilderCardChooseColorContextMenuItem/>
		{/*<MenuDivider/>*/}
	</Fragment>}

    <DefaultCatalogContextMenuItems/>
  </Fragment>)
})

export const SendContextCardsToWhiteboardMenuItem = observer(function SendContextCardsToWhiteboardMenuItem() {
    const store = useBuilderCardStore(),
      fieldStore = useCardFieldStore(),
      {catalog: {selection}, isSelected, stores: {deployments: {deploymentConfig}}} = store

  if (!selection || !deploymentConfig?.settings?.whiteboard) return null

  const {selectedIds, sendSelectionToWhiteboard } = selection,
    count = isSelected ? selectedIds.size : 1,
      countText = count < 2 ? '' : ` (${count})`,
      {flexLayout: {tabsByComponent}} = store,
    whiteboards = tabsByComponent['whiteboard']

  return (<ContextMenuItem icon={icons.whiteboard} text={`Send to Whiteboard${countText}`} onClick={() => sendSelectionToWhiteboard({idToSend: !isSelected ? store.idWithPath : undefined})} >
    {_.isEmpty(whiteboards)
     ? undefined
     : _.size(whiteboards) === 1
       ? <SendContextCardsToSpecificWhiteboardMenuItems tab={_.first(whiteboards)} />
       : whiteboards.map((w, i) => (
         <ContextMenuItem icon={'blank'} text={`${w.displayName}`} key={i}>
           <SendContextCardsToSpecificWhiteboardMenuItems tab={w} />
         </ContextMenuItem>
        ))
    }

  </ContextMenuItem>)
})

export const SendContextCardsToSpecificWhiteboardMenuItems = observer<{tab: TabNode}>(function SendContextCardsToSpecificWhiteboardMenuItems({tab}) {
  const store = useBuilderCardStore(),
    fieldStore = useCardFieldStore(),
    {catalog: {selection}} = store

  if (!selection) return null

  const wb = tab?.config as IFlexLayoutWhiteboardTabConfig

  if (!wb) return null

  const {whiteboard: {pages, ui: {currentPageId}}} = wb,
    pagesInOrder = _.orderBy(_.values(pages), p => p.page.childIndex),
    {sendSelectionToWhiteboard} = selection,
    idToSend = selection.selectedIds.has(store.idWithPath) ? undefined : store.idWithPath

  return (<Fragment>
    {pagesInOrder.map(
      ({page}, i) => (
      <ContextMenuItem
        key={i}
                       icon={<NumberBadge>{i + 1}</NumberBadge>}
        text={page.name ?? `Page`}
        active={currentPageId === page.id}
        onClick={() => sendSelectionToWhiteboard({page: page, tab, idToSend})}
      />))}
    <MenuDivider />
    <ContextMenuItem
      icon={'new-object'}
      text={'New Page'}
      onClick={() => sendSelectionToWhiteboard({tab, idToSend})} />

  </Fragment>)
})

const CreateSpecifiedCatalogItems = observer(function CreateSpecifiedCatalogItems() {
  const cardStore = useBuilderCardStore(),
    {_fieldByName} = useCatalog()

  const store = useNewWorkspaceRelationshipStore(),
    {} = store
  return (<WorkspaceRelationshipStoreContext.Provider value={store}>
    <ContextMenuItem icon='fork' text='Create Related Items...'>

    </ContextMenuItem>
  </WorkspaceRelationshipStoreContext.Provider>)
})

export const ShowFieldTitlesMenuItem = observer(function ShowFieldTitlesMenuItem() {
  const {settings, settings: {showCardLabels}} = useCatalog()
  return (<Fragment>
    <ContextMenuItem onClick={() => settings.showCardLabels = !showCardLabels} icon={showCardLabels ? 'tick' : icons.fieldLabels} text='Show Field Titles'/>
  </Fragment>)
})
export const SurfaceNestedFieldsToggleMenuItem = observer(function SurfaceNestedFieldsToggleMenuItem() {
  const {settings, settings: {showNestedFieldsOnTopLevelCard}} = useCatalog()
  return (<Fragment>
    <ContextMenuItem onClick={() => settings.showNestedFieldsOnTopLevelCard = !showNestedFieldsOnTopLevelCard} icon={showNestedFieldsOnTopLevelCard ? 'tick' : icons.nestedFields} text='Show Nested Fields'/>
  </Fragment>)
})

const ImageSourcesContextMenuToolbar = observer(function ImageSourcesContextMenuToolbar() {
  const {imageSourceOptions, imageSource, settings: {imageSource: {ids}}, toggleImageSource} = useCatalog()
  if (imageSourceOptions.length < 1) return null

  return <MenuDivider className={classNames(css.titleDivider, css.imageSources)} title={<div className={css.toolbar}>
    <div className={css.inlineButtons}>
      {imageSourceOptions.map(({background, field, label, id}, i) => {
        const title = label ?? _.capitalize(field)
        return (
            <PrimaryIconButton
              tooltip={title}
              key={i}
              icon={<span>{_.capitalize(_.first(title))}</span>}
              active={ids.includes(id)}
              onClick={() => toggleImageSource(id)}/>
          )
      })}
    </div>
  </div>}/>
})

const ProductCardInlinePreviewSubmenu = observer(function ProductCardInlinePreviewSubmenu() {
  const store = useBuilderCardStore(),
    {catalog, workspaces} = store,
    onlyPreview = catalog.features?.card?.contextMenu?.noCardMenuItems

  return (
    <CatalogItemPreviewMenuItem data={store.data} index={catalog.index} workspace={store.props.workspace ?? workspaces.workspaceConfig} noSubmenuPadding={onlyPreview}>
      {onlyPreview ? <LoadFullSizeCardForContextProductCard id={store.id} workspace={store.props.workspace}/> :
       <Fragment>
         {/*<ImageSourcesContextMenuToolbar/>*/}
         <InlineBuilderCardMenuItem_BuilderCard children={null}/>

         <ContextMenuItem text='More Details' noSubmenuPadding children={<LoadFullSizeCardForContextProductCard id={store.id} workspace={store.props.workspace}/>}/>
         <MenuDivider/>

         {true && <Fragment>
           {false && store.isEditable && catalog.isActionButtonEnabled('changeColor') && <Fragment>
             {/*<ContextMenuItem icon={<ImageSharp/>} text={'Upload Image(s)'} noSubmenuPadding>*/}
             {/*  <UppyImageUploader/>*/}
             {/*</ContextMenuItem>*/}
			   <BuilderCardChooseColorContextMenuItem/>
		   </Fragment>}

			 <BuilderCardRelationshipsContextMenuItem dividerBefore wrapWithMenuItem={false}/>
		 </Fragment>}
       </Fragment>}
    </CatalogItemPreviewMenuItem>
  )
})

const PublishCatalogItemMenuItem = observer<ContextMenuItemProps>(function PublishCatalogItemMenuItem(props) {
  const {canPublish, isOffline, uploadToC8, strings} = useBuilderCardStore()
  return isOffline && <Fragment>
	  <ContextMenuItem {...props} icon={icons.publish} text={strings.publish} disabled={!canPublish} onClick={uploadToC8}/>
  </Fragment>
})

const BuilderCardChooseColorContextMenuItem = observer(function BuilderCardChooseColorContextMenuItem() {
  const {data, catalog} = useBuilderCardStore()

  if (!catalog.isActionButtonEnabled('changeColor', data)) return null

  const colorImage = (data?.images ?? []).find(img => img.rgba)

  return (
    <ContextMenuItem noSubmenuPadding icon={<PaletteSharp/>} text={'Choose Color(s)'}>
      <div className={css.colorPickerSubmenuPanel}>
        <SketchPicker
          color={colorImage?.rgba}
          onChange={color => {
            if (!data.images) {
              data.images = []
            }

            if (colorImage) {
              colorImage.rgba = color.rgb
            } else {
              data.images.push({rgba: color.rgb})
            }
          }}/>
      </div>
    </ContextMenuItem>
  )
})

const BuilderStoreContextItemMenuItem = observer(function BuilderStoreContextItemMenuItem() {
  const {contextItem, contextItemField} = useBuilderCardStore(),
    catalog = useCatalog()

  if (!contextItemField || !contextItem) return null

  const {data, meta} = contextItem

  return <SpecContextMenuItem menuLook data={data} index={contextItemField.esIndex} workspace={catalog.workspaceByIndex[contextItemField.esIndex]} field={contextItemField}/>
})

export const ImageSourceGridSliders = observer<{ className?: string, tooltipLocation?: TooltipLocation }>(function ImageSourceGridSliders(props) {
  const {settings: {viewMode, imageSource: {view, grid}}} = useCatalog()
  if (viewMode != 'card' || view != 'grid') return null

  return (
    <div className={css.gridImageSourceSliders}>
      <CardSizeSlider tooltipTitle={`${grid.columns} Columns`} {...props} max={5} min={1} step={1} value={grid.columns}
                      zoomOutIcon={<ViewWeek/>} zoomInIcon={<ViewColumn/>}
                      onChange={(e, v: number) => grid.columns = v}/>
      <CardSizeSlider tooltipTitle={`${grid.rows} Rows`} {...props} max={5} min={1} step={1} value={grid.rows ?? 3}
                      zoomOutIcon={<VerticalAlignTop/>} zoomInIcon={<PlaylistAdd/>}
                      onChange={(e, v: number) => grid.rows = v}/>

    </div>
  )
})

export const StackedCardSpreadSlider = observer<{ className?: string, tooltipLocation?: TooltipLocation }>(function StackedCardSpreadSlider({className, tooltipLocation}) {
  const {settings: {viewMode, imageSource: {view, stackedCards, grid}}, assortments, componentStores} = useCatalog()
  if (viewMode != 'card' || view != 'stack') return null
  if (assortments?.selectedAssortment && componentStores.assortmentRoots['catalog']?.isCollapsedAll) {
    return null
  }

  return (
    <CardSizeSlider tooltipTitle='Card Spread' className={className} max={100} min={0} value={stackedCards.spread * 100}
                    zoomOutIcon={<RecentActors/>} zoomInIcon={<ViewColumn/>} tooltipLocation={tooltipLocation}
                    onChange={(e, v: number) => stackedCards.spread = v / 100}/>
  )
})

export const ImageSourcesMenuItem = observer(function ImageSourcesMenuItem() {
  const {settings: {viewMode}} = useCatalog()

  return viewMode === 'card' &&
         <ContextMenuItem icon={<ImageSearchSharp/>} text='Image Source'>
	         <ImageSourcesMenuContent/>
         </ContextMenuItem>
})

/**
 * Should be surrounded by a <Menu /> or be a child of an existing <MenuItem />
 */
export const ImageSourcesMenuContent = observer(function ImageSourcesContentMenu() {
  const {settings: {imageSource: {toolbar, view}}, settings} = useCatalog()
  const { localSelectedImageSourceIds } = useImageSourceToolbarButtonStore()

  return (<Fragment>
    <MenuDivider className={css.menuHeader}
                 title={
                   <div className={css.imageSourcesTitle}>
                     <span>Image Sources</span>
                     <div className={classNames(css.inlineButtons)}>
                       <PrimaryIconButton icon={<Filter1/>}
                                          tooltip='First'
                                          tooltipPosition='top'
                                          active={view === 'first'}
                                          onClick={action((e) => {
                                            e.stopPropagation()
                                            // catalog.toggleImageSource(id)
                                            settings.imageSource.view = 'first'
                                          })}/>
                       <PrimaryIconButton
                         tooltip='Grid View'
                         tooltipPosition='top'
                         icon={<ViewComfy/>}
                         active={view === 'grid'}
                         onClick={(e) => {
                           e.stopPropagation()
                           // catalog.toggleImageSource(id)
                           settings.imageSource.view = 'grid'
                         }}/>
                       <PrimaryIconButton
                         tooltip='Stacked View'
                         tooltipPosition='top'
                         icon={<Layers/>} active={view === 'stack'}
                         onClick={(e) => {
                           e.stopPropagation()
                           // catalog.toggleImageSource(id)
                           settings.imageSource.view = 'stack'
                         }}/>
                       <PrimaryIconButton
                           tooltip='Clear Selected'
                           tooltipPosition='top'
                           icon={<Icon icon='clean'/>}
                           onClick={(e) => {
                             e.stopPropagation()

                             localSelectedImageSourceIds?.clear();
                           }}/>
                     </div>
                     {false && <div className={css.toolbar}>
			             <PrimaryIconButton icon='add-row-top' tooltip={'Move to Header'} active={toolbar.location === 'header'} onClick={() => toolbar.location = 'header'}/>
			             <PrimaryIconButton icon='add-row-bottom' tooltip={'Move to Footer'} active={toolbar.location === 'footer'} onClick={() => toolbar.location = 'footer'}/>
		             </div>}
                   </div>}/>
    <CatalogImageSourceMenuItems/>
    <CatalogImageSourceSelectedWidgetsMenuItems/>
  </Fragment>)
})

export const CatalogImageSourceSelectedWidgetsMenuItems = observer(function CatalogImageSourceSelectedWidgetsMenuItems() {
  const {settings: {imageSource: {view, stackedCards}}} = useCatalog()

  return (
    <Fragment>
      {view === 'stack' &&
	   <Fragment>
		   <MenuDivider title='Image Stack Properties'/>
		   <StackedCardSpreadSlider/>
		   <MenuDivider/>
		   <ScaleOnHoverSlider/>
	   </Fragment>}

      {view === 'grid' &&
	   <Fragment>
		   <MenuDivider title='Image Grid Properties'/>
		   <ImageSourceGridSliders/>
		   {/*<MenuDivider/>
		   <ScaleOnHoverSlider/>*/}
	   </Fragment>}

    </Fragment>)
})

const ScaleOnHoverSlider = observer(function ScaleOnHoverSlider() {
  const {settings: {imageSource, imageSource: {scaleOnHover}}} = useCatalog()
  return (
    <CardSizeSlider min={1} step={.05} max={1.75}
                    value={scaleOnHover ?? 1}
                    onChange={(e, v: number) => imageSource.scaleOnHover = v} tooltipTitle={'Zoom on Hover'}/>
  )
})

export const ImageRatiosMenuItem = observer(function ImageRatiosMenuItem() {
  return <ContextMenuItem icon={<AspectRatioSharp/>} text='Image Ratio'>
    <CardImageRatioMenuItems/>
  </ContextMenuItem>
})

const ToggleLevelOfDetail = observer<ContextMenuItemProps>(function ToggleLevelOfDetailMenuItem(props) {
  const {levelOfDetail, toggleLocalLOD} = useBuilderCardStore(),
    {settings} = useCatalog()

  return settings.levelOfDetail === 1
         ? null
         : <ContextMenuItem
           {...props}
           icon={levelOfDetail == 0 ? 'zoom-in' : 'zoom-out'}
           text={`${levelOfDetail ? 'Hide' : 'Show'} Inline Details`}
           onClick={toggleLocalLOD}/>
})

//
const OpenProductDetails = observer(function OpenProductDetailsMenuItem() {
  const {openCatalogItemDetails, toggleCatalogItemDetails, isShowingDetails, props: {workspace}} = useBuilderCardStore(),
    catalog = useCatalog()
  return (<Fragment>
    <ContextMenuItem icon='menu-open' text={`${workspace?.itemName ?? catalog.catalogItemName} Details...`} shouldDismissPopover onClick={e => toggleCatalogItemDetails(null, !isShowingDetails)}>
      {isShowingDetails &&
	   <Fragment>
		   <ContextMenuItem icon='menu-closed' text={`Close details`} onClick={e => toggleCatalogItemDetails(e, false)}/>
		   <MenuDivider/>
	   </Fragment>}
      <ContextMenuItem icon={icons.modal} text={'Open in Tab'} shouldDismissPopover onClick={e => openCatalogItemDetails(null, 'modal')}/>
      <ContextMenuItem icon={icons.sidebar} text={'Open in Sidebar'} onClick={e => openCatalogItemDetails(null, 'sidebar')}/>
    </ContextMenuItem>
  </Fragment>)
})

const ShowHideInlineDetails = observer(function ShowHideInlineDetailsMenuItem() {
  return (
    <ContextMenuItem icon='blank' text={'todo'} onClick={undefined}/>
  )
})

export const LoadFullSizeCardForContextProductCard = observer<{ id: string, field?: ICatalogFieldConfig, workspace: Partial<WorkspaceConfig>, noImage?: boolean }>(({noImage, id, workspace, field}) => {
  return <BuilderCardLoader id={id} levelOfDetail={1} hideButtons isPopover useDefaultFieldsIfNoneSet showImage={!noImage} workspace={workspace} field={field}/>
})

export const InlineBuilderCardMenuItem_BuilderCard = observer<{ small?: boolean, orientation?: Orientation, showText?: boolean }>(function InlineBuilderCardMenuItem_BuilderCard({small, orientation, showText, children}) {
  const {cardTitle, imageUrl, workspaces, id} = useBuilderCardStore(),
    workspace = workspaces.workspaceConfig

  return <InlineBuilderCardMenuItem workspace={workspace} title={cardTitle} imageUrl={imageUrl} id={id} children={children}/>
})

export const InlineBuilderCardMenuItem = observer<{ workspace: WorkspaceConfig, title?: string, small?: boolean, orientation?: Orientation, showText?: boolean, imageUrl?: ImageUrlWithHD | string, id: string }>(
  function InlineBuilderCardMenuItem({title, imageUrl, id, workspace, small, orientation, showText, children}) {
    const {catalog} = useStores(),
      cardFieldStore = useCardFieldStore()

    /*{/!*<div className={css.builderCardTitleContainer}>*!/}
    {/!*  <ContextMenuItem_Submenu_NoPadding*!/}*/

    // console.log({children, cardFieldStore, cardTitle, id})
    return <Fragment>
      <ContextMenuItem
        icon={null}
        className={classNames(GroupByGroupContextMenu.css.groupTitleMenuItem, css.groupTitleMenuItem, !small && css.biggerImageNoBottomPadding, small && css.small)}
        data-orientation={orientation ?? 'vertical'}
        href={nav.urlForWorkspace({workspace, itemId: id}, true)}
        //onClick={openCatalogItemDetails}  // Annoying behavior
        noSubmenuPadding={_.isUndefined(children) && !cardFieldStore}
        text={
          <div className={classNames(GroupByGroupContextMenu.css.groupTitle, css.groupTitle)} data-object-fit={catalog.objectFitFor(workspace)}>
            <MyImage imageUrl={imageUrl} className={classNames(GroupByGroupContextMenu.css.swatch, css.swatch)} noImageContent={<NoImagePlaceholder/>}/>
            {showText && <span className={css.title}>
            <div className={Classes.FILL}>{title}</div>

              {!small && <Icon icon='caret-right'/>}
          </span>}
          </div>}>
        {!_.isUndefined(children) ? children : !cardFieldStore && <LoadFullSizeCardForContextProductCard id={id} workspace={workspace}/>}
      </ContextMenuItem>
      {/*<MenuDivider/>*/}
    </Fragment>
  })

export const FullSizePreviewMenuItem = observer(function FullSizePreviewMenuItem({children}) {
  const {id, props: {workspace}} = useBuilderCardStore()

  return (<ContextMenuItem text={`Preview...`} icon={icons.previewCard}>
    {children ?? <LoadFullSizeCardForContextProductCard id={id} workspace={workspace}/>}
  </ContextMenuItem>)
})

const GoBack = observer(function GoBack() {
  const {contextMenu, strings} = useStores()
  const {canGoBack} = (contextMenu ?? {})
  return canGoBack ? <ContextMenuItem icon='arrow-left' text={strings.goBack} onClick={nav.history.goBack}/> : null
})

const GoToSeason = observer<ContextMenuItemProps>(function GoToSeason(props) {
  const catalog = useCatalog(),
    {navigateToSeason, seasonSelectorFieldsNonNull} = useBuilderCardStore(), {seasonSelectorFields} = catalog

  return _.isEmpty(seasonSelectorFields) || catalog.seasonSelector.inASeason || !seasonSelectorFieldsNonNull.length ? null : (
    <ContextMenuItem {...props} icon={icons.goToSeason} text={'Go to Season'} onClick={navigateToSeason}/>
  )
})

const CopyCatalogItem = observer(function DuplicateCatalogItemMenuItem() {
  const {cardTitle} = useBuilderCardStore(),
    catalog = useCatalog()

  return (
    <ContextMenuItem
      text={`Copy ${catalog.catalogItemName}`}
      icon={'clipboard'}
      onClick={undefined}/>
  )
})

class PasteImagesMenuItemStore extends VipLocalStore {
  constructor(ws) {
    super(ws)
  }

  @observable.ref clipboardData

  @action onClick = async (e: React.MouseEvent) => {
    try {
      const r = await navigator.clipboard.read()

      _.forEach(r, async (item: ClipboardItem) => {
        if (item.types.includes('image/png')) {
          const data = await item.getType('image/png')
          console.log(data)
        }
        console.log(item)
      })
    } catch (err) {
      console.log(err)
    }
  }
}

// const PasteImagesMenuItem = observer(function PasteImagesMenuItem() {
//   const catalog = useCatalog(),
//     {strings, data} = useBuilderCardStore(), {isActionButtonEnabled} = catalog,
//     store = useVipLocalStore(ws => new PasteImagesMenuItemStore(ws)),
//     {onClick} = store
//
//   if (!isActionButtonEnabled('uploadImages', data)) return null
//
//   useEffect(() => {
//     runInAction(async () => {
//       if (document.hasFocus()) {
//         try {
//           const r = await navigator.clipboard.read()
//           store.clipboardData = r
//           console.log(r)
//         } catch (err) {
//           console.error(err)
//         }
//       }
//     })
//   }, [])
//
//   return (<ContextMenuItem shouldDismissPopover text={`${strings.pasteImages}`} icon='clipboard' onClick={onClick}/>)
// })

const DuplicateCatalogItem = observer(function DuplicateCatalogItemMenuItem() {
  const catalog = useCatalog(),
    {onDuplicate, strings, isIncludedInMultiSelect, data} = useBuilderCardStore(), {catalogItemName, selection: {duplicateSelectedCatalogItems, selectedIds}, isActionButtonEnabled} = catalog,
    cardFieldStore = useCardFieldStore()

  if (!isActionButtonEnabled('duplicate', data)) return null

  const suffix = cardFieldStore ? ` ${catalogItemName}` : ``

  // return <ContextMenuItem shouldDismissPopover text={`${strings.duplicate}${suffix}`} icon='layers' onClick={e => onDuplicate(null, true)}/>

  return (
    !isIncludedInMultiSelect ? <ContextMenuItem shouldDismissPopover text={`${strings.duplicate}${suffix}`} icon={icons.duplicate} onClick={e => onDuplicate(null, true)}/>
                             : <ContextMenuItem shouldDismissPopover text={`${strings.duplicate}${suffix} ${pluralize(catalog.catalogItemName, selectedIds.size)}${selectedIds.size ? ` (${selectedIds.size})` : ''}`} icon='layers' onClick={duplicateSelectedCatalogItems}/>
  )
})

const DeleteCatalogItem = observer(function DeleteCatalogItem() {
  const {onDelete, isIncludedInMultiSelect, data, strings} = useBuilderCardStore(),
    catalog = useCatalog(),
    {selection: {deleteSelectedProducts, selectedIds}, catalogItemName, isActionButtonEnabled} = catalog,
    cardFieldStore = useCardFieldStore()

  if (!isActionButtonEnabled('delete', data)) return null

  const suffix = cardFieldStore ? ` ${catalogItemName}` : ``

  return (
    !isIncludedInMultiSelect ? <ContextMenuItem shouldDismissPopover text={`${strings.delete}${suffix}`} icon='trash' onClick={e => onDelete(null)}/>
                             : <ContextMenuItem shouldDismissPopover text={`${strings.delete}${suffix} ${pluralize(catalog.catalogItemName, selectedIds.size)}${selectedIds.size ? ` (${selectedIds.size})` : ''}`} icon='trash' onClick={deleteSelectedProducts}/>
  )
})

//<ContextMenuItem text={strings.delete} icon='trash' onClick={undefined}/>
const ToggleActive = observer(function ToggleActive() {
  const {isActive, onToggleActive, catalog, cardTitle, showToggleActive, strings} = useBuilderCardStore(),
    cardFieldStore = useCardFieldStore()

  if (!showToggleActive) return null

  return (
    <ContextMenuItem icon={isActive ? icons.inactive : icons.active}
                     text={`${strings.toggleActive(catalog, isActive, cardFieldStore != null)} '${cardTitle}'`}
                     onClick={onToggleActive}/>
  )
})

const SortByContextMenuItem = observer<{ level?: number }>(function SortByContextMenuItem({level}) {
  const {strings} = useStores()

  return <ContextMenuItem icon='sort' text={`${strings.sortBy}...`}>

  </ContextMenuItem>
})



// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/BuilderCardContextMenu.tsx